import { businessExternalOperatorsPageBreadcrumbs } from './config/breadcrumbs';
import { Authorize, NavigateLinks } from '@/components';
import { useNavigate } from 'react-router-dom';
import { icons } from '@/assets';
import { useMemo } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const RESTRICTED_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.restricted,
];

const EXTERNAL_OPERATOR_PERMISSIONS = [...EXTERNAL_OPERATOR_ROLE_GROUPS.all];

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

export const BusinessExternalOperators = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => businessExternalOperatorsPageBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='w-full h-full flex flex-col gap-8 p-5'>
      <NavigateLinks actualPage='Sistema de envíos' breadcrumbs={breadcrumbs} />
      <section className='w-full h-full flex flex-col items-center'>
        <ul className='h-full w-full max-w-[calc(4*200px+3*50px)] grid grid-cols-[repeat(auto-fit,200px)] content-center justify-center gap-[50px]'>
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-external-operators/shippings')}
          >
            <img
              src={icons.preparePackage}
              alt='Icono de pedidos'
              className='h-[90px] object-contain'
            />
            <p className='text-center'>Envíos</p>
          </li>
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-external-operators/monitoring')}
          >
            <img
              src={icons.routes}
              alt='Icono de gestión de rutas'
              className='h-[90px] object-contain'
            />
            <p className='text-center'>Gestión de Rutas</p>
          </li>
          <li
            className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
            onClick={() => navigate('/business-external-operators/drivers')}
          >
            <img
              src={icons.drivers}
              alt='Icono de conductores'
              className='h-[90px] object-contain'
            />
            <p className='text-center'>Conductores</p>
          </li>
          <Authorize permission={ADMIN_PERMISSIONS} fallback={null}>
            <li
              className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() =>
                navigate('/business-external-operators/logistics-management')
              }
            >
              <img
                src={icons.serviceHistory}
                alt='Icono de gestión logística'
                className='h-[90px] object-contain'
              />
              <p className='text-center'>Gestión Logística</p>
            </li>
          </Authorize>
          <Authorize permission={RESTRICTED_PERMISSIONS} fallback={null}>
            <li
              className='w-[200px] py-[10px] px-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() => navigate('/business-external-operators/batch-checkpoints')}
            >
              <img
                src={icons.statusChange}
                alt='Icono de cambio de estado múltiple'
                className='h-[125px] mt-[-18px] mb-[-15px] ml-[-12px] object-contain'
              />
              <p className='text-center mb-3'>Cambio de Estado Múltiple</p>
            </li>
          </Authorize>
          <Authorize permission={RESTRICTED_PERMISSIONS} fallback={null}>
            <li
              className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() => navigate('/business-external-operators/amendments')}
            >
              <img
                src={icons.invoice}
                alt='Icono de enmiendas'
                className='h-[90px] object-contain'
              />
              <p className='text-center'>Enmiendas</p>
            </li>
          </Authorize>
          <Authorize permission={EXTERNAL_OPERATOR_PERMISSIONS} fallback={null}>
            <li
              className='w-[200px] p-[25px] aspect-[4/3] flex flex-col justify-between items-center bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105'
              onClick={() => navigate('/business-external-operators/jobs')}
            >
              <img
                src={icons.monitor}
                alt='Icono de mis archivos'
                className='h-[90px] object-contain'
              />
              <p className='text-center'>Mis archivos</p>
            </li>
          </Authorize>
        </ul>
      </section>
    </section>
  );
};

export default BusinessExternalOperators;
